import React from "react";
import { ArrowUpRight, Linkedin, ExternalLink } from "lucide-react";
import { founder, experience } from "../mock";

const MeetFounder = () => {
  return (
    <section id="founder" className="icg-section">
      <div className="icg-container grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5 md:sticky md:top-28 self-start">
          <div className="relative overflow-hidden rounded-3xl aspect-[4/5] bg-[color:var(--icg-cream-soft)]">
            <img
              src={founder.image}
              alt={founder.name}
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute bottom-5 left-5 right-5 bg-[color:var(--icg-cream)] rounded-2xl p-4 shadow-lg">
              <div className="text-xs uppercase tracking-widest text-[color:var(--icg-muted)]">
                {founder.discipline}
              </div>
              <div className="font-display text-xl font-semibold mt-1">
                {founder.name}
              </div>
              <div className="text-sm text-[color:var(--icg-muted)]">
                {founder.role}
              </div>
              <div className="mt-4 flex gap-2">
                <a
                  href={founder.linkedin}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-1.5 text-xs font-medium px-3 py-2 rounded-full bg-[color:var(--icg-ink)] text-[color:var(--icg-cream)] hover:bg-[color:var(--icg-accent)] hover:text-[color:var(--icg-ink)] transition-colors"
                >
                  <Linkedin size={12} /> LinkedIn
                </a>
                <a
                  href={founder.portfolio}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-1.5 text-xs font-medium px-3 py-2 rounded-full border border-[color:var(--icg-line)] hover:bg-[color:var(--icg-ink)] hover:text-[color:var(--icg-cream)] transition-colors"
                >
                  <ExternalLink size={12} /> Portfolio
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="md:col-span-7 md:pl-8">
          <span className="icg-eyebrow">
            <span className="icg-dot" /> Meet the founder
          </span>
          <h2
            className="font-display font-semibold tracking-tight mt-5"
            style={{ fontSize: "clamp(36px, 5vw, 64px)", lineHeight: 1.02 }}
          >
            Hi, I&rsquo;m{" "}
            <span className="font-serif-it text-[color:var(--icg-accent)]">
              Monica
            </span>
            .
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-[color:var(--icg-ink-soft)]">
            {founder.bio}
          </p>
          <p className="mt-4 text-[color:var(--icg-muted)] leading-relaxed">
            {founder.focus}
          </p>

          <div className="mt-8 grid sm:grid-cols-2 gap-6">
            <div>
              <div className="text-xs uppercase tracking-widest text-[color:var(--icg-muted)]">
                Selected clients
              </div>
              <div className="mt-3 flex flex-wrap gap-2">
                {founder.clients.map((c) => (
                  <span
                    key={c}
                    className="text-sm px-3 py-1.5 rounded-full border border-[color:var(--icg-line)] bg-[color:var(--icg-cream)]"
                  >
                    {c}
                  </span>
                ))}
              </div>
            </div>
            <div>
              <div className="text-xs uppercase tracking-widest text-[color:var(--icg-muted)]">
                Toolbelt
              </div>
              <div className="mt-3 flex flex-wrap gap-2">
                {founder.toolbelt.map((t) => (
                  <span
                    key={t}
                    className="text-sm px-3 py-1.5 rounded-full border border-[color:var(--icg-line)] bg-[color:var(--icg-cream)]"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div className="mt-14">
            <div className="text-xs uppercase tracking-widest text-[color:var(--icg-muted)]">
              Career highlights
            </div>
            <ol className="mt-6 relative border-l border-[color:var(--icg-line)] pl-6 space-y-8">
              {experience.map((e, i) => (
                <li key={i} className="relative">
                  <span className="absolute -left-[31px] top-1.5 h-3 w-3 rounded-full bg-[color:var(--icg-accent)] ring-4 ring-[color:var(--icg-cream)]" />
                  <div className="text-xs font-display uppercase tracking-widest text-[color:var(--icg-muted)]">
                    {e.period}
                  </div>
                  <div className="mt-1 font-display font-semibold text-xl tracking-tight">
                    {e.role}
                  </div>
                  <div className="text-sm text-[color:var(--icg-ink-soft)]">
                    {e.org} · {e.location}
                  </div>
                  <p className="mt-2 text-sm text-[color:var(--icg-muted)] leading-relaxed max-w-2xl">
                    {e.note}
                  </p>
                </li>
              ))}
            </ol>
          </div>

          <a href="#work" className="mt-12 icg-btn icg-btn--dark inline-flex">
            See Monica&rsquo;s work <ArrowUpRight size={16} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default MeetFounder;
